'use strict';
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const trackingUtils = require('od-modules/utils/tracking.utils');

const DEFAULT_TIMEOUT = 5000;

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend({
    CSS_CLASSES: {
        INITIAL: 'odf-message-with-arrow-bottom-center od-bubble-initial',
        POSITIONED: 'odf-message-with-arrow-right-center odf-position-absolute',
    },

    selectors: {
        bubbleBody: '.discount_bubble_membership_body',
        discountBubbleText: '.membership_discount_bubble_text',
    },

    initialize(options) {
        const observerOptions = {
            rootMargin: `0px 0px -${this.$cachedSelectors.bubbleBody[0].offsetHeight}px 0px`,
        };
        this.model.set('bookingId', options.bookingId);
        this.model.set('positioned', false);
        // Workaround: The hotel widget is in viewport while other widgets render and there's no way to know when they are done (iframes, etc).
        setTimeout( () => {
            this.startObserving(observerOptions);
            this.$cachedSelectors.bubbleBody.removeClass('od-bubble-transparent');
        }, Number.parseInt(this.keys.discountBubbleAnimationTimeout, 10) || DEFAULT_TIMEOUT);
        this.replaceTextWithCode();
    },

    replaceTextWithCode() {
        const formattedCode = `<span class="odf-bold od-discount-bubble-highlight-text">` + this.keys.hotelDiscountCode + `</span>`;
        const discountBubbleTextFilled = Odigeo.Utils.replaceCmsKeyArgs(this.keys.hotelDiscountBubbleText, formattedCode);
        this.$el.find(this.selectors.discountBubbleText).append(discountBubbleTextFilled);
    },

    changeBubblePosition() {
        this.stopObserving();
        if (!this.model.get('positioned')) {
            const label = `positioned_id:${this.model.get('bookingId')}`;
            trackingUtils.trackEventWithCategory('my_area_trip_details', 'widget_hotel_discount_bubble', label);
            this.$cachedSelectors.bubbleBody.toggleClass(this.CSS_CLASSES.INITIAL, false).toggleClass(this.CSS_CLASSES.POSITIONED, true);
            this.model.set('positioned', true);
        }
    },

    // Internal functions
    startObserving(observerOptions) {
        this.intersectionObserver = new IntersectionObserver((entries) => entries.map(this.intersectionHandler.bind(this)), observerOptions);
        this.intersectionObserver.observe(this.el);
        this.model.set('observerConnected', true);
    },

    stopObserving() {
        if (this.model.get('observerConnected')) {
            this.intersectionObserver.unobserve(this.el);
            this.intersectionObserver.disconnect();
            this.model.set('observerConnected', false);
        }
    },

    intersectionHandler(observerEntry) {
        if (observerEntry.isIntersecting) {
            this.changeBubblePosition();
        }
    },
})));
